import { BranchResponseDto, CostAppraisalResponseDto, MemberResponseDto, PurchaseResponseDto, UserRoleResponseDto } from '@api';

import { ActiveEnum, PublishTypeEnum } from './StatusEnum';

export const PublishTypeEnumText = {
  [PublishTypeEnum.Publish]: `Publish`,
  [PublishTypeEnum.Inactive]: `Unpublish`,
};

export const StatusEnumText = {
  [ActiveEnum.Active]: `Active`,
  [ActiveEnum.Inactive]: `Inactive`,
};

export const GenderEnumText = {
  'male': `ชาย`,
  'female': `หญิง`,
};

export const MembersGetEntityTypeEnumText = {
  [MemberResponseDto.EntityTypeEnum.Corporate]: `นิติบุคคล`,
  [MemberResponseDto.EntityTypeEnum.Individual]: `บุคคลธรรมดา`,

};


export const CostAppraisalStatusEnumText = {
  [CostAppraisalResponseDto.StatusEnum.Active]: `Active`,
  [CostAppraisalResponseDto.StatusEnum.InActive]: `Inactive`,
  [CostAppraisalResponseDto.StatusEnum.Draft]: `Draft`,
};


export const UserGroupEnumText = {
  [UserRoleResponseDto.UserGroupEnum.ExecutiveWpn]: `ผู้บริหาร WPN`,
  [UserRoleResponseDto.UserGroupEnum.CentralStaffWpn]: `พนักงานส่วนกลาง WPN`,
  [UserRoleResponseDto.UserGroupEnum.BranchStaffWpn]: `พนักงานสาขา WPN`,
  [UserRoleResponseDto.UserGroupEnum.BranchExecutiveFranchise]: `ผู้บริหารสาขา Franchise`,
  [UserRoleResponseDto.UserGroupEnum.BranchStaffFranchise]: `พนักงานสาขา Franchise`,
};

export const BranchTypeEnumText = {
  [BranchResponseDto.TypeEnum.Franchise]: `Franchise`,
  [BranchResponseDto.TypeEnum.Wpn]: `Wpn`,
}

export const PurchaseStatusEnumText = {
  [PurchaseResponseDto.StatusEnum.PendingBulkSale]: `อยู่ระหว่างบันทึกข้อมูล`,
  [PurchaseResponseDto.StatusEnum.PendingReview]: `รอตรวจสอบ`,
  [PurchaseResponseDto.StatusEnum.PendingPayment]: `รอชำระเงิน`,
  [PurchaseResponseDto.StatusEnum.Paid]: `ชำระแล้ว`,
  [PurchaseResponseDto.StatusEnum.Rejected]: `ไม่อนุมัติ`,
}

export const PaidByEnumText = {
  [PurchaseResponseDto.PaidByEnum.Cash]: `เงินสด`,
  [PurchaseResponseDto.PaidByEnum.Bank]: `โอนผ่านธนาคาร`,
}

export const PaidBankTypeEnumText = {
  [PurchaseResponseDto.PaidBankTypeEnum.SavedAccount]: `บัญชีที่บันทึกไว้`,
  [PurchaseResponseDto.PaidBankTypeEnum.CustomAccount]: `บัญชีธนาคารที่ต้องการ`,
  [PurchaseResponseDto.PaidBankTypeEnum.Promptpay]: `พร้อมเพย์`,
}